import { Component, Input } from '@angular/core';
// import { LocalDataSource } from 'ng2-smart-table';

@Component({
  selector: 'ngx-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent {

  // source: LocalDataSource = new LocalDataSource();


  @Input() user: any;
}
